<template>
    <div>
        <Loader :show="loading"></Loader>
        <template v-if="!loading">
            <Banner :banners="banners" show-overlay> </Banner>
            <Breadcrumb></Breadcrumb>
            <div class="info-wrapper default">
                <h2 class="title text-center">親子共遊會呼吸的河</h2>
                <p class="html-wrapper" v-html="detail.description"></p>
                <div class="route-wrapper green">
                    <div class="title">親子共遊半日遊推薦－遊程路線</div>
                    <ol class="route-breadcrumb">
                        <li
                            v-for="attraction in detail.attractions"
                            :key="attraction.id"
                            v-text="attraction.name"
                        >
                            柳川水岸步道
                        </li>
                    </ol>
                </div>
                <div
                    class="detail-card green"
                    v-for="(attraction, index) in detail.attractions"
                    :key="attraction.id"
                    :class="{
                        'mb-3 dotted': detail.attractions.length - 1 !== index,
                    }"
                >
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-2">
                            <div
                                class="circle mr-2 align-self-baseline flex-shrink-0"
                                v-text="index + 1"
                            >
                                1
                            </div>
                            <div class="title mr-2">
                                <a
                                    href=""
                                    @click.prevent="
                                        goAttractionsDetail(attraction.id)
                                    "
                                    v-text="attraction.name"
                                >
                                    柳川水岸步道
                                </a>
                            </div>
                            <button
                                class="btn btn-how ml-auto flex-shrink-0 align-self-baseline"
                                @click="
                                    goGoogleMap([
                                        attraction.lon,
                                        attraction.lat,
                                    ])
                                "
                            >
                                <img
                                    src="@/assets/part_ic_inquire.png"
                                    alt="如何到達"
                                />如何到達
                            </button>
                        </div>
                        <vue-load-image class="mb-2">
                            <img
                                slot="image"
                                :src="
                                    `${apiPhotoUrl}/ori/${attraction.photoId}`
                                "
                                :alt="attraction.name"
                                class="detail-img"
                            />
                            <img
                                slot="preloader"
                                src="@/assets/image-loader.gif" class="w-100"
                            />
                            <img
                                slot="error"
                                class="border d-block detail-img"
                                src=""
                                alt="not found"
                            />
                        </vue-load-image>
                        <p class="info-text" v-html="attraction.description">
                            白天的柳川呈現悠閒的氣息，水質清澈，可近距離欣賞水中的錦鯉，非常適合情侶下午散步出門的好去處唷!
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import Loader from '@/components/Loader';
import { apiTourDetail } from '@/plugin/api';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/family_img.jpg'),
                },
            ],
            loading: false,
            detail: {},
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        goAttractionsDetail(id) {
            this.$router.push(`/guide/attractions/${id}`);
        },
        async getDetail() {
            this.loading = true;
            await apiTourDetail(1).then((res) => {
                if (res.data.success) {
                    // eslint-disable-next-line arrow-parens
                    res.data.data.attractions = res.data.data.attractions.map(
                        (item) => ({
                            ...item,
                            lat: +item.latitude,
                            lon: +item.longitude,
                            name: item.name,
                            id: item.attractionId,
                        }),
                    );
                    this.detail = res.data.data;
                }
            }, this.errorHandler);
            this.loading = false;
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
